exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#login-btn,#register-btn{display:block;width:100%}.block-forgot-password{line-height:24px;margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules?sourceMap!./vendor/sections/auth/login.useable.css
// module id = 784
// module chunks = 0